import { Component } from '@angular/core';
import { MatDialogActions, MatDialogContent, MatDialogRef } from '@angular/material/dialog';
import { MatButton } from '@angular/material/button';

@Component({
  standalone: true,
  selector: 'app-disabled-auto-payment-dialog',
  templateUrl: './disabled-auto-payment-dialog.component.html',
  styleUrls: ['./disabled-auto-payment-dialog.component.scss'],
  imports: [
    MatDialogActions,
    MatButton,
    MatDialogContent,
  ],
})
export class DisabledAutoPaymentDialogComponent {
  constructor(private dialogRef: MatDialogRef<DisabledAutoPaymentDialogComponent>) {}

  close(): void {
    this.dialogRef.close();
  }
}
